import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import axios from '@/app/api/axios.js';
import i18n from '@/app/lang/i18n.js';
import { unexpectedError } from '@/shared/utils/unexpected-error.js';
import { useRouter } from 'vue-router';

export const useInvoicesStore = defineStore('invoices', () => {
    const router = useRouter();

    const searchQuery = ref('');
    const selectedInvoices = ref([]);

    const setActiveInvoice = async (id) => {
        await router.push({ name: 'single invoice', params: { invoice: id } });
    };

    const isDownloadingInvoice = ref(false);
    const downloadInvoice = async (invoice) => {
        isDownloadingInvoice.value = true;

        try {
            const response = await axios.get(`/general/invoices/${invoice.id}/download`, {
                responseType: 'blob',
            });

            const fileUrl = window.URL.createObjectURL(response.data);
            const anchorElement = document.createElement('a');

            anchorElement.href = fileUrl;
            anchorElement.download = i18n.global.t('invoices.invoice') + `-${invoice.number}.pdf`;
            anchorElement.style.display = 'none';

            document.body.appendChild(anchorElement);

            anchorElement.click();
            anchorElement.remove();

            window.URL.revokeObjectURL(fileUrl);
        } catch (e) {
            unexpectedError(e, i18n.global.t('invoices.could_not_download_pdf'));
        } finally {
            isDownloadingInvoice.value = false;
        }
    };

    const hasSelectedInvoices = computed(() => {
        return selectedInvoices.value.length > 0;
    });

    const hasReachedSelectedLimit = computed(() => {
        return selectedInvoices.value.length >= 3;
    });

    return {
        searchQuery,
        selectedInvoices,
        hasSelectedInvoices,
        hasReachedSelectedLimit,
        isDownloadingInvoice,
        setActiveInvoice,
        downloadInvoice,
    };
});
